import React, { Component } from 'react';
import {Segment, Grid, Header,Image} from 'semantic-ui-react'

class About extends Component {

  render() {
    return (
      <Segment style={{ padding: '8em 0em' }} vertical>
          <Grid container stackable verticalAlign='middle'>
            <Grid.Row>
              <Grid.Column width={8}>
                <Header as='h3' style={{ fontSize: '2em' }}>Always Building</Header>
                <p style={{ fontSize: '1.33em' }}>
                I was raised among the farm land of Langley, BC, in a house filled with artifacts of the late 90s tech boom. This setting grew an urge to build and fix and developed an affinity  for all things electronic.
                </p>
                <p style={{ fontSize: '1.33em' }}>
                The decision to enter UBC computer engineering was only natural. Since then,
                my projects have ranged from web applications to wooden kayaks, surfboards to
                drone detecting software.
                </p>
                <Header as='h3' style={{ fontSize: '2em' }}>But also...</Header>
                <p style={{ fontSize: '1.33em' }}>
                  In my free time, I enjoy, snowboarding, surfing, biking and camping. The latter two culminating in a recent self supported bike trip to California.
                </p>
              </Grid.Column>
              <Grid.Column floated='right' width={6}>
                <Image
                  bordered
                  rounded
                  size='large'
                  src='http://tlgraham.com/profile2edit.jpg'
                />
              </Grid.Column>
            </Grid.Row>

          </Grid>
        </Segment>
    );
  }

}

export default About;



// WEBPACK FOOTER //
// ./src/Content/Pages/About.js